/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useRef, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BaseHosts, Actions, Path } from './constants';

export const YahooIframe = ({
  id,
  action,
  jwtToken,
  customerId,
  accountId,
  country,
  locale,
  isProd,
}) => {
  const baseHost = isProd ? BaseHosts.Prod : BaseHosts.Int;

  const actionEndpoint = `${baseHost}/${Path}/${Actions[action]}`;

  const [frameHeight, setFrameHeight] = useState();

  const formRef = useRef(null);

  useLayoutEffect(() => {
    formRef.current.submit();

    const callback = (evt) => {
      if (evt.origin === baseHost && evt.data.action === action) {
        setFrameHeight(`${evt.data.height}px`);
      }
    };

    window.addEventListener('message', callback);

    return () => {
      window.removeEventListener('message', callback);
    };
  }, [action, baseHost]);

  return (
    <div id={id} className="yahoo-iframe-container">
      <iframe name={`${id}-frame`} id={`${id}-frame`} className="yahoo-iframe" style={{ height: frameHeight }} />
      <form name={`${id}-form`} id={`${id}-form`} method="POST" target={`${id}-frame`} action={actionEndpoint} ref={formRef}>
        <input type="hidden" name="jwt" value={jwtToken} />
        <input type="hidden" name="locale" value={locale} />
        <input type="hidden" name="custId" value={customerId} />
        <input type="hidden" name="accountId" value={accountId} />
        <input type="hidden" name="country" value={country} />
      </form>
    </div>
  );
};

YahooIframe.propTypes = {
  id: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  jwtToken: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  accountId: PropTypes.string,
  country: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  isProd: PropTypes.bool.isRequired,
};

YahooIframe.defaultProps = {
  accountId: undefined,
};
